import { Toggle as MatchboxToggle } from '@sparkpost/matchbox';

/**
 * Matchbox Toggle component.
 * @see https://design.sparkpost.com/components/toggle/
 */
const Toggle = MatchboxToggle;

export default Toggle;
